(() => {
  'use strict';
  const cart = window.BasicCart;
  if (!cart) return;

  const backdrop = document.createElement('div');
  backdrop.className = 'cart-drawer-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  const drawer = document.createElement('div');
  drawer.className = 'cart-drawer';
  drawer.id = 'cart-drawer';
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.setAttribute('aria-labelledby', 'cart-drawer-title');
  drawer.setAttribute('aria-hidden', 'true');
  drawer.inert = true;
  drawer.innerHTML = window.BasicShopifyConfig.transformHTML(`
    <div class="cart-drawer-head">
      <div><h2 class="cart-drawer-title" id="cart-drawer-title">Ton panier<span>.</span></h2><span class="cart-drawer-count" id="cart-drawer-count">0 sélection</span></div>
      <button class="cart-drawer-close" type="button" aria-label="Fermer le panier"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M5 5l14 14M19 5 5 19"/></svg></button>
    </div>
    <div class="cart-drawer-body">
      <div class="cart-drawer-rewards" id="cart-drawer-rewards" hidden></div>
      <div class="cart-drawer-empty" id="cart-drawer-empty"><img src="assets-palette/applicateur-deodorant-rechargeable-kiima-kit-de-depart.webp" alt="" /><h3>Ton panier est vide.</h3><a href="kit-deodorant.html">Découvrir le kit déodorant <span aria-hidden="true">→</span></a></div>
      <div class="cart-drawer-items" id="cart-drawer-items"></div>
    </div>
    <div class="cart-drawer-footer" id="cart-drawer-footer" hidden>
      <div class="cart-drawer-totals"><div><span>Sous-total</span><strong id="cart-drawer-subtotal">CHF 0.–</strong></div><div><span>Livraison Suisse</span><strong id="cart-drawer-shipping">CHF 7.–</strong></div><div class="cart-drawer-total"><span>Total</span><strong id="cart-drawer-total">CHF 0.–</strong></div><div class="cart-drawer-savings" id="cart-drawer-savings-row" hidden><span>Économies</span><strong id="cart-drawer-savings">CHF 0.–</strong></div></div>
      <p class="cart-drawer-uncertain" id="cart-drawer-uncertain" hidden>Un prix reste à confirmer.</p>
      <button id="cart-drawer-checkout" class="cart-drawer-checkout" type="button" disabled><span>Passer au paiement</span><span aria-hidden="true">→</span></button>
      <a class="cart-drawer-secondary" href="panier.html">Voir le panier</a>
      <div class="cart-drawer-payments" aria-label="Moyens de paiement" hidden></div>
    </div>
    <p class="cart-drawer-live" id="cart-drawer-live" role="status" aria-live="polite"></p>
  `);
  document.body.append(backdrop,drawer);

  const find = id => drawer.querySelector(`#${id}`);
  const closeButton = drawer.querySelector('.cart-drawer-close');
  const empty = find('cart-drawer-empty');
  const itemsContainer = find('cart-drawer-items');
  const footer = find('cart-drawer-footer');
  const rewardsContainer = find('cart-drawer-rewards');
  const rewards = window.BasicCartRewards.create();
  rewardsContainer.append(rewards);
  const subtotal = find('cart-drawer-subtotal');
  const savingsRow = find('cart-drawer-savings-row');
  const savingsAmount = find('cart-drawer-savings');
  const shipping = find('cart-drawer-shipping');
  const total = find('cart-drawer-total');
  const uncertainNote = find('cart-drawer-uncertain');
  const live = find('cart-drawer-live');
  const payments = drawer.querySelector('.cart-drawer-payments');
  let opener = null;
  let originalInert = [];

  function renderPayments() {
    const icons = Array.isArray(window.BasicShopifyConfig?.paymentIcons) ? window.BasicShopifyConfig.paymentIcons : [];
    const priority = ['visa','master','american_express','twint','apple_pay','google_pay','shopify_pay','klarna','unionpay','usdc'];
    const rank = icon => {const index = priority.indexOf(icon.type); return index < 0 ? priority.length : index;};
    const badges = icons.filter(icon => !['unionpay','usdc'].includes(icon.type) && icon.label && typeof icon.svg === 'string' && /^\s*<svg\b/i.test(icon.svg)).sort((a,b) => rank(a) - rank(b)).map(icon => {
      const badge = document.createElement('span');
      badge.className = 'cart-drawer-payment-icon';
      badge.setAttribute('role', 'img');
      badge.setAttribute('aria-label', icon.label);
      badge.innerHTML = icon.svg;
      badge.querySelector('svg')?.setAttribute('aria-hidden', 'true');
      badge.querySelector('svg')?.setAttribute('focusable', 'false');
      return badge;
    });
    payments.replaceChildren(...badges);
    payments.hidden = !badges.length;
  }

  function localPage(item) {
    return /^[a-z0-9-]+\.html$/.test(item.page || '') ? item.page : 'index.html';
  }

  function changeQuantity(id, delta, action) {
    const items = cart.read();
    const item = items.find(entry => entry.id === id);
    if (!item) return;
    item.quantity = Math.max(1, Math.min(cart.MAX_QUANTITY, item.quantity + delta));
    cart.write(items);
    render();
    live.textContent = `Quantité mise à jour pour ${item.title}.`;
    itemsContainer.querySelector(`button[data-item="${id}"][data-action="${action}"]`)?.focus();
  }

  function remove(id) {
    const items = cart.read();
    const item = items.find(entry => entry.id === id);
    if (!item) return;
    cart.write(items.filter(entry => entry.id !== id));
    render();
    live.textContent = `${item.title} retiré du panier.`;
    closeButton.focus();
  }

  function renderLine(item) {
    const row = document.createElement('article');
    row.className = 'cart-drawer-line';
    const imageLink = document.createElement('a');
    imageLink.className = 'cart-drawer-image';
    imageLink.href = localPage(item);
    imageLink.setAttribute('aria-label', `Revoir ${item.title}`);
    const image = document.createElement('img');
    image.src = cart.imageUrl(item.image);
    image.alt = '';
    image.loading = 'lazy';
    imageLink.append(image);
    const info = document.createElement('div');
    info.className = 'cart-drawer-info';
    const title = document.createElement('a');
    title.className = 'cart-drawer-line-title';
    title.href = localPage(item);
    title.textContent = item.title;
    const detail = document.createElement('p');
    detail.className = 'cart-drawer-line-detail';
    detail.textContent = item.detail || '';
    const controls = document.createElement('div');
    controls.className = 'cart-drawer-controls';
    const quantity = document.createElement('div');
    quantity.className = 'cart-drawer-quantity';
    quantity.setAttribute('role', 'group');
    quantity.setAttribute('aria-label', `Nombre de sélections de ${item.title}`);
    const minus = document.createElement('button');
    minus.type = 'button';
    minus.textContent = '−';
    minus.disabled = item.quantity <= 1;
    minus.setAttribute('aria-label', `Retirer une sélection de ${item.title}`);
    minus.dataset.item = item.id;
    minus.dataset.action = 'minus';
    minus.addEventListener('click', () => changeQuantity(item.id,-1,'minus'));
    const output = document.createElement('output');
    output.textContent = String(item.quantity);
    const plus = document.createElement('button');
    plus.type = 'button';
    plus.textContent = '+';
    plus.disabled = item.quantity >= cart.MAX_QUANTITY;
    plus.setAttribute('aria-label', `Ajouter une sélection de ${item.title}`);
    plus.dataset.item = item.id;
    plus.dataset.action = 'plus';
    plus.addEventListener('click', () => changeQuantity(item.id,1,'plus'));
    quantity.append(minus,output,plus);
    const removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'cart-drawer-remove';
    removeButton.textContent = 'Retirer';
    removeButton.setAttribute('aria-label', `Retirer ${item.title} du panier`);
    removeButton.addEventListener('click', () => remove(item.id));
    controls.append(quantity,removeButton);
    info.append(title,detail,controls);
    const price = document.createElement('strong');
    price.className = 'cart-drawer-line-price';
    price.textContent = item.price === null ? 'À confirmer' : cart.money(item.price * item.quantity);
    info.append(price);
    const savings = cart.savingsFor(item);
    if (savings > 0) {
      const saving = document.createElement('span');
      saving.className = 'cart-drawer-line-savings';
      saving.textContent = `${cart.money(savings)} économisés`;
      info.append(saving);
    }
    row.append(imageLink,info);
    return row;
  }

  function render() {
    const items = cart.read();
    renderPayments();
    const hasItems = items.length > 0;
    empty.hidden = hasItems;
    footer.hidden = !hasItems;
    rewardsContainer.hidden = !hasItems;
    const summary = cart.totals(items);
    itemsContainer.replaceChildren(...items.map(renderLine), ...(summary.giftUnlocked ? [window.BasicCartRewards.giftLine()] : []));
    find('cart-drawer-count').textContent = `${summary.selectionCount} ${summary.selectionCount === 1 ? 'sélection' : 'sélections'}`;
    if (!hasItems) return;
    const {known,savings,delivery,promotionRisk,missingPrice,uncertain} = summary;
    subtotal.textContent = missingPrice ? `${cart.money(known)} + à confirmer` : cart.money(known);
    savingsRow.hidden = savings <= 0;
    savingsAmount.textContent = cart.money(savings);
    shipping.textContent = delivery === 0 ? 'Offerte' : cart.money(delivery);
    total.textContent = missingPrice ? 'À confirmer' : cart.money(known + delivery);
    window.BasicCartRewards.render(rewards, summary);
    uncertainNote.hidden = !uncertain;
  }

  function open(source = document.activeElement) {
    if (drawer.getAttribute('aria-hidden') === 'false') {render();return;}
    opener = source instanceof HTMLElement ? source : null;
    render();
    originalInert = [...document.body.children].filter(child => child !== drawer && child !== backdrop).map(child => [child,child.inert]);
    originalInert.forEach(([child]) => {child.inert = true;});
    drawer.inert = false;
    drawer.setAttribute('aria-hidden','false');
    backdrop.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-drawer-open');
    closeButton.focus();
    const summary = cart.totals();
    if (summary.loaded) window.BasicConversionAnalytics?.track('basic:cart_drawer_opened', {
      location:'cart_drawer', item_count:summary.selectionCount,
      currency:summary.currency, value:summary.known
    });
  }

  function close() {
    if (drawer.getAttribute('aria-hidden') !== 'false') return;
    document.body.classList.remove('cart-drawer-open');
    drawer.setAttribute('aria-hidden','true');
    backdrop.setAttribute('aria-hidden','true');
    drawer.inert = true;
    originalInert.forEach(([child,wasInert]) => {child.inert = wasInert;});
    originalInert = [];
    opener?.focus();
  }

  document.querySelectorAll('.cart-link').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    open(link);
  }));
  backdrop.addEventListener('click', close);
  closeButton.addEventListener('click', close);
  drawer.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
  document.addEventListener('keydown', event => {
    if (drawer.getAttribute('aria-hidden') !== 'false') return;
    if (event.key === 'Escape') {event.preventDefault();close();return;}
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a,button')].filter(element => !element.disabled && !element.closest('[hidden]'));
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
  });
  window.addEventListener('basic-cart-change', render);
  window.addEventListener('storage', render);
  window.BasicCartDrawer = {open,close,render};
  render();
})();
